import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23;

import styled, { css } from 'styled-components';
import { ExpansionIndicator } from '../ExpansionIndicator';
import { TextInput } from '../TextInput';
import { Pack, PackItem } from '../Pack';
import { Tag } from '../Tag';
import { SINGLE_LINE_MAX_ALLOWED_HEIGHT } from './constants';
import { marginAttributes, widthAttributes, color, spacing, propsBlocker, getComponentOverride } from '../../system';
export var DropdownRoot = styled.div.withConfig(propsBlocker)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: inline-block;\n\n    ", ";\n    ", ";\n"])), marginAttributes, widthAttributes);
export var DropdownContainer = styled.div.withConfig(propsBlocker)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n"])));

var getOptionListContainerStyle = function getOptionListContainerStyle(_ref) {
  var zIndex = _ref.zIndex;
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        z-index: ", ";\n    "])), zIndex);
};

export var DropdownOptionListContainer = styled.div.withConfig(propsBlocker)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    ", ";\n"])), getOptionListContainerStyle);

var dropdownExpansionIndicatorContentStyle = function dropdownExpansionIndicatorContentStyle(_ref2) {
  var multiple = _ref2.multiple;
  return multiple ? css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n              align-items: flex-start;\n              margin-top: ", ";\n          "])), spacing(2.5)) : css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n              height: ", ";\n          "])), spacing(8));
};

export var ExpansionIndicatorContainer = styled.div.withConfig(propsBlocker)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    align-self: stretch;\n"])));
export var DropdownExpansionIndicator = styled(ExpansionIndicator)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    cursor: pointer;\n\n    .ExpansionIndicator-Content {\n        width: ", ";\n\n        ", "\n    }\n"])), spacing(14), dropdownExpansionIndicatorContentStyle);

var dropdownTextRootStyle = function dropdownTextRootStyle(_ref3) {
  var multiple = _ref3.multiple;
  var result = {};

  if (multiple) {
    result = css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n            ", ";\n            min-width: ", ";\n        "])), result, spacing(70));
  }

  return result;
};

var dropdownTextInputStyle = function dropdownTextInputStyle(_ref4) {
  var disabled = _ref4.disabled,
      multiple = _ref4.multiple,
      isCustomRenderer = _ref4.isCustomRenderer,
      internalValue = _ref4.internalValue;
  var result = css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n        cursor: ", ";\n    "])), disabled ? 'default' : 'pointer');

  if (multiple && !isCustomRenderer && internalValue.length) {
    result = css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n            ", ";\n            padding-right: 0;\n            padding-left: 0;\n            width: 0;\n        "])), result);
  }

  return result;
};

export var DropdownTextInput = styled(TextInput)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    ", "\n\n    .TextInput-Input {\n        ", "\n    }\n"])), dropdownTextRootStyle, dropdownTextInputStyle);

var dropdownBeforeSectionContainerStyle = function dropdownBeforeSectionContainerStyle(_ref5) {
  var disabled = _ref5.disabled,
      singleLine = _ref5.singleLine;
  var result = css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n        cursor: ", ";\n    "])), disabled ? 'default' : 'pointer');

  if (singleLine) {
    result = css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n            ", ";\n            height: ", "px;\n        "])), result, SINGLE_LINE_MAX_ALLOWED_HEIGHT);
  }

  return result;
};

export var DropdownBeforeSectionRoot = styled(Pack)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n    padding-left: ", ";\n    padding-right: ", ";\n    min-width: ", ";\n    min-height: ", ";\n    width: 100%;\n\n    ", "\n"])), spacing(4), spacing(4), spacing(40), spacing(10), dropdownBeforeSectionContainerStyle);
export var DropdownBeforeSectionTagsContainer = styled(PackItem)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n    width: 100%;\n    padding-top: ", ";\n    padding-bottom: ", ";\n"])), spacing(1), spacing(1));
export var DropdownBeforeSectionTagsWrapper = styled.div.withConfig(propsBlocker)(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n    width: fit-content;\n"])));
export var DropdownBeforeSectionActionContainer = styled(PackItem)(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n    width: ", ";\n"])), spacing(4));

var dropdownBeforeSectionClearButtonStyle = function dropdownBeforeSectionClearButtonStyle(_ref6) {
  var disabled = _ref6.disabled;
  return css(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n        color: ", ";\n        cursor: ", ";\n    "])), disabled ? color('neutral.04') : color('neutral.06'), disabled ? 'default' : 'pointer');
};

export var DropdownBeforeSectionClearButton = styled(PackItem)(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n    position: absolute;\n    border: 0 none;\n    background-color: transparent;\n    outline: none;\n    flex: 0 0 auto;\n    margin-top: ", ";\n    margin-left: ", ";\n    ", "\n\n    ", ";\n"])), spacing(2.5), spacing(2), dropdownBeforeSectionClearButtonStyle, getComponentOverride('DropdownBeforeSectionClearButton'));

var dropdownTagStyle = function dropdownTagStyle(_ref7) {
  var disabled = _ref7.disabled;
  return css(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n        cursor: ", ";\n    "])), disabled ? 'default' : 'pointer');
};

export var DropdownTag = styled(Tag).attrs({
  small: true
})(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n    margin-top: ", ";\n    margin-right: ", ";\n    margin-bottom: ", ";\n\n    .Typography-Root {\n        margin-left: ", ";\n        margin-right: ", ";\n    }\n    ", ";\n"])), spacing(1), spacing(2), spacing(1), spacing(1), spacing(1), dropdownTagStyle);
export var DropdownArrow = styled.div(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral([""])));